import { Form, FormProps } from "@/components/form";
import { Stack, Typography } from "@mui/material";
import { z } from "zod/v4";
import { getAllOrganizaciones } from "../../organizaciones/api/get-all-organizaciones";
import { getOrganizacion } from "../../organizaciones/api/get-organizacion";
import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Permiso } from "@/shared/types/permiso";

export const editUsuarioFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    numDocumento: z.string().nonempty("Este campo es requerido"),
    organizacionId: z.string().optional(),
    email: z.email(),
    telefono: z.string(),
    direccion: z.string(),
})

export default function EditUsuarioForm({
    form,
    ...props
}: FormProps<z.infer<typeof editUsuarioFormSchema>>) {
    const { hasPermisos } = useAuthContext();
    const canManageOrganizaciones = hasPermisos(Permiso.ManageOrganizaciones);

    return <Form form={form} gap={3} {...props}>
        <Stack gap={2}>
            <Typography component={"h2"} variant="h6">Datos Obligatorios</Typography>
            <Form.TextField name="nombre" label="Nombre" />
            <Form.TextField name="numDocumento" label="N° Documento" />
            {canManageOrganizaciones && (
                <Form.ModelComboBox name="organizacionId" label="Organización" get={getOrganizacion} getAll={getAllOrganizaciones} />
            )}
            <Form.EmailField name="email" label="Email" />
        </Stack>

        <Stack gap={2}>
            <Typography component={"h2"} variant="h6">Datos Personales</Typography>
            <Form.TextField name="telefono" label="Teléfono" />
            <Form.TextField name="direccion" label="Dirección" />
        </Stack>

        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}